import { MetadataModel } from '@thehubz/client/core';
import { AssetMetadata } from '@thehubz/shared/model';

export const SeatMandatoryField: MetadataModel[] = [
  {
    formControlName: '_id',
    formFieldName: $localize`Asset Id`,
    selected: true,
  },
  {
    formControlName: 'name',
    formFieldName: $localize`Name`,
    selected: true,
  },
  {
    formControlName: 'status',
    formFieldName: $localize`Status`,
    selected: true,
  },
  {
    formControlName: 'assetType',
    formFieldName: $localize`Asset type`,
    selected: true,
  },
  {
    formControlName: 'domains',
    formFieldName: $localize`Domains`,
    selected: true,
  },
  {
    formControlName: 'createdAt',
    formFieldName: $localize`Created at`,
    selected: true,
  },
  {
    formControlName: 'createdBy',
    formFieldName: $localize`Created by`,
    selected: true,
  },
  {
    formControlName: AssetMetadata.General.TAGS,
    formFieldName: $localize`Tags`,
    selected: true,
  },
  {
    formControlName: 'customFields',
    formFieldName: $localize`Custom fields`,
    selected: true,
    hideField: true,
  },
];

export const SeatNonMandatoryField: MetadataModel[] = [
  {
    formControlName: 'mediaType',
    formFieldName: $localize`Media type`,
    customField: true,
  },
  {
    formControlName: 'channels',
    formFieldName: $localize`Channels`,
    customField: true,
  },
  {
    formControlName: 'shortDescription',
    formFieldName: $localize`Short description`,
    customField: true,
  },
  {
    formControlName: 'modelYear',
    formFieldName: $localize`Model year`,
    customField: true,
  },
  {
    formControlName: 'trim',
    formFieldName: $localize`Trim`,
    customField: true,
  },
  {
    formControlName: 'specialModel',
    formFieldName: $localize`Special model`,
    customField: true,
  },
  {
    formControlName: 'drive',
    formFieldName: $localize`Drive`,
    customField: true,
  },
  {
    formControlName: 'vehicleColor',
    formFieldName: $localize`Vehicle color`,
    customField: true,
  },
  {
    formControlName: 'specialFeature',
    formFieldName: $localize`Special feature`,
    customField: true,
  },
  {
    formControlName: 'usageRights',
    formFieldName: $localize`Usage rights`,
    formFieldGroup: [
      { formControlName: 'image', formFieldName: 'Buyout-Informationen (Image)' },
      { formControlName: 'music', formFieldName: 'Musik/Sound' },
      { formControlName: 'talents', formFieldName: 'Talents' },
      { formControlName: 'voiceover', formFieldName: 'Voice-over' },
      { formControlName: 'Zusatzinformationen', formFieldName: 'Zusatzinformationen (Notes)' },
    ],
  },
];
